/*
  Restyle homepage Bazaarvoice (Curalate) gallery arrows to use
  custom-pill-icon-button chrome and brand chevron icons.
  On mobile, drive a below-gallery control bar like other carousels.
*/
(function () {
  var GALLERY_SELECTOR = '.bazaarvoice-gallery';
  var ROOT_SELECTOR = '.bazaarvoice-gallery [crl8-container-id]';
  var BUTTON_SELECTOR = 'button[aria-label^="Previous slide"], button[aria-label^="Next slide"]';

  var ICON_PREV =
    '<svg class="custom-top-shelf-carousel-arrow" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M29 2L11 20L29 38" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  var ICON_NEXT =
    '<svg class="custom-top-shelf-carousel-arrow custom-top-shelf-carousel-arrow--next" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M29 2L11 20L29 38" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  var enhancedRoots = new WeakSet();

  function isPrev(button) {
    var label = button.getAttribute('aria-label') || '';
    return label.indexOf('Previous slide') === 0;
  }

  function nativeButton(root, direction) {
    var prefix = direction === 'prev' ? 'Previous slide' : 'Next slide';
    return root.querySelector('button[aria-label^="' + prefix + '"]');
  }

  function styleButton(button) {
    if (!(button instanceof Element)) return;
    if (button.classList.contains('custom-bazaarvoice-gallery__control')) return;
    if (button.querySelector('.custom-top-shelf-carousel-arrow')) return;

    var prev = isPrev(button);

    button.classList.add(
      'custom-pill-icon-button',
      'hover-scale',
      'custom-bazaarvoice-gallery__nav',
      prev ? 'custom-bazaarvoice-gallery__nav--prev' : 'custom-bazaarvoice-gallery__nav--next'
    );

    if (button.parentElement) {
      button.parentElement.classList.add('custom-bazaarvoice-gallery__nav-wrap');
    }

    button.innerHTML = prev ? ICON_PREV : ICON_NEXT;
  }

  function updateControls(gallery, root) {
    var prev = gallery.querySelector('.custom-bazaarvoice-gallery__control--prev');
    var next = gallery.querySelector('.custom-bazaarvoice-gallery__control--next');
    var pager = gallery.querySelector('.custom-bazaarvoice-gallery__pagination');
    var nativePrev = nativeButton(root, 'prev');
    var nativeNext = nativeButton(root, 'next');

    if (prev) {
      prev.disabled = !nativePrev;
      prev.classList.toggle('is-disabled', !nativePrev);
    }

    if (next) {
      next.disabled = !nativeNext;
      next.classList.toggle('is-disabled', !nativeNext);
    }

    if (nativePrev || nativeNext) {
      gallery.classList.add('bazaarvoice-gallery--ready');
    }

    if (pager) {
      var status = root.querySelector('[aria-live="assertive"], [role="status"]:not(.custom-bazaarvoice-gallery__pagination)');
      var text = (status && status.textContent) || '';
      var match = text.match(/Slidepanel\s+(\d+)\s+of\s+(\d+)/i) || text.match(/(\d+)\s+of\s+(\d+)/i);
      var label = match ? match[1] + '/' + match[2] : '';

      if (match && pager.dataset.bvTotal !== match[2]) {
        pager.style.width = '';
        pager.textContent = match[2] + '/' + match[2];
        var width = Math.ceil(pager.getBoundingClientRect().width);
        if (width > 0) {
          pager.style.width = width + 'px';
          pager.dataset.bvTotal = match[2];
        }
      }

      if (pager.dataset.bvPager !== label) {
        pager.dataset.bvPager = label;
        pager.textContent = label;
      }
    }
  }

  function bindControls(gallery, root) {
    if (gallery.dataset.bvControlsBound === 'true') return;
    gallery.dataset.bvControlsBound = 'true';

    var prev = gallery.querySelector('.custom-bazaarvoice-gallery__control--prev');
    var next = gallery.querySelector('.custom-bazaarvoice-gallery__control--next');

    function trigger(direction) {
      var native = nativeButton(root, direction);
      if (native) native.click();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        trigger('prev');
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        trigger('next');
      });
    }
  }

  function styleGallery(root) {
    if (!(root instanceof Element)) return;
    root.querySelectorAll(BUTTON_SELECTOR).forEach(styleButton);

    var gallery = root.closest(GALLERY_SELECTOR);
    if (!gallery) return;
    bindControls(gallery, root);
    updateControls(gallery, root);
  }

  function watchGallery(root) {
    if (!(root instanceof Element) || enhancedRoots.has(root)) return;
    enhancedRoots.add(root);
    styleGallery(root);

    new MutationObserver(function () {
      styleGallery(root);
    }).observe(root, { childList: true, subtree: true });
  }

  function scan() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(watchGallery);
  }

  if (document.body) {
    new MutationObserver(scan).observe(document.body, { childList: true });
  }

  scan();
})();
